import Decimal from "decimal.js";

// Define the interface
export interface ISale {
  investment: Decimal;
  user: string;
  isUsdtPurchase: boolean;
  tokensTransferred: Decimal;
  profit: Decimal;
  purchaseTime: Date;
  code: string;
}

// Define the class
export class Sale implements ISale {
  investment: Decimal;
  user: string;
  isUsdtPurchase: boolean;
  tokensTransferred: Decimal;
  profit: Decimal;
  purchaseTime: Date;
  code: string;

  constructor(data: any) {
    this.investment = new Decimal(data.investment);
    this.user = data.user;
    this.isUsdtPurchase = data.isUsdtPurchase;
    this.tokensTransferred = new Decimal(data.tokensTransferred);
    this.profit = new Decimal(data.profit);
    this.purchaseTime = new Date(Number(data.purchaseTime) * 1000);
    this.code = "";
  }

  // Convert an ethers.js response (array format) into a Sale instance
  static fromEthersResponse(response: any[]): Sale {
    return new Sale({
      user: response[0],
      profit: new Decimal(response[1].toString()),
      isUsdtPurchase: response[2],
      investment: new Decimal(response[3].toString()),
      tokensTransferred: new Decimal(response[4].toString()),
      purchaseTime: new Date(Number(response[5])),
      code: "",
    });
  }

  toJSON(): Record<string, any> {
    return {
      investment: this.investment.toString(),
      user: this.user,
      isUsdtPurchase: this.isUsdtPurchase,
      tokensTransferred: this.tokensTransferred.toString(),
      profit: this.profit.toString(),
      purchaseTime: this.purchaseTime.getTime(),
      code: this.code,
    };
  }

  static fromJSON(json: Record<string, any>): Sale {
    return new Sale({
      investment: new Decimal(json.investment),
      user: json.user,
      isUsdtPurchase: json.isUsdtPurchase,
      tokensTransferred: new Decimal(json.tokensTransferred),
      profit: new Decimal(json.profit),
      purchaseTime: new Date(json.purchaseTime),
      code: json.code,
    });
  }
}
